import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import PortalSnackbar from '../PortalSnackbar';

export const FooterActionBar = ({ selectedItemsCount, actionComponents = [], onClose, id }) => {
  return (
    <>
      {selectedItemsCount > 0 && (
        <PortalSnackbar
          id={`${id}__snackbar_footerBulkAction`}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          isOpen={selectedItemsCount > 0}
          onClose={onClose}
          ClickAwayListenerProps={{ onClickAway: () => null }} // To not close the snackbar on external click
          ContentProps={{
            sx: {
              background: 'white',
              borderRadius: 2,
              border: '1px solid #ddd',
              color: 'inherit',
            },
          }}
          sx={{
            '& .MuiIconButton-root svg': {
              color: 'black',
            },
          }}
          message={
            <Stack
              id={`${id}__stack_footerBulkAction`}
              direction={{ sm: 'column', md: 'row' }}
              gap={1}
              alignItems="center"
              width="100%"
            >
              <Box
                id={`${id}__box_footerBulkAction_wrapper`}
                sx={{
                  backgroundColor: '#1F8098',
                  color: '#fff',
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  borderRadius: '8px',
                  minWidth: '50px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50px',
                }}
              >
                {selectedItemsCount}
              </Box>
              <Typography id={`${id}__text_footerBulkAction_item_count`}>
                Item{selectedItemsCount > 1 && 's'} selected
              </Typography>
              <Stack
                id={`${id}__stack_footerBulkAction_actions`}
                direction={{ sm: 'column', md: 'row' }}
                gap={1}
                width={{ xs: '100%', md: 'auto' }}
              >
                {actionComponents}
              </Stack>
            </Stack>
          }
        />
      )}
    </>
  );
};
